import {
  EventTypes,
  track,
  trackKeyGrowthEvent,
  getPageSource,
} from '@mc/track-event'
import { getPageEventName } from '@mc/pre-paywall-events'
import {
  ActionTypes,
  KeyTypes,
  saveUserData,
  getTrackedId,
} from '@mc/user-data'

// https://masterclass-dev.atlassian.net/wiki/spaces/DATA/pages/2250178561/WIP+Category+Page+Redesign+Tracking+Spec#Top-Nav-Category-Click-Tracking
export const trackCategoryNavClicked = (slug: string) => {
  const eventName = getPageEventName()

  track(eventName, {
    action: 'top_nav_category_selected',
    location: 'top_nav',
    category: slug,
  })
}

export const trackSubcategoryCarouselNavClicked = (
  category: string,
  subcategoryId: number,
) => {
  const key = KeyTypes.SUBCATEGORY
  const subcatId = getTrackedId({ key, id: subcategoryId })
  const eventName = getPageEventName()

  track(eventName, {
    action: 'subcat_carousel_navigation_clicked',
    location: 'subcat_carousel',
    category,
    stored_subcategory_id: subcatId,
  })

  saveUserData({
    key,
    id: subcatId,
    actionType: ActionTypes.BROWSING,
    eventName,
  })
}

// https://masterclass-dev.atlassian.net/wiki/spaces/DATA/pages/2250178561/Category+Page+Redesign+Tracking+Spec#Sub-Category-Click-Tracking
export const trackSubcategoryClicked = ({
  categorySlug,
  subcategoryName,
}: {
  categorySlug: string
  subcategoryName: string
}) => {
  const eventsProps = {
    action: 'sub_category_nav_selected',
    location: 'sub_category_nav',
    subcategory_name: subcategoryName,
    category: categorySlug,
  }

  track(EventTypes.SUBCATEGORY_CLICK, {
    ...eventsProps,
  })
}

// masterclass-dev.atlassian.net/wiki/spaces/DATA/pages/2250178561/Category+Page+Redesign+Tracking+Spec#Section%2FRow-Viewed-Tracking
const rowIndexMapping = {
  hero: 0,
  sub_category_link_section: 1,
  main_category_carousel: 2,
  sub_category_carousel: 3,
  start_your_journey: 4,
  subscription_benefits_section: 5,
  faq_section: 6,
  sign_up_bottom_section: 7,
  email_collection_section: 8,
} as const

export const trackCatalogPageRowViewed = ({
  rowName,
  categorySlug,
  uiState = 'visible',
}: {
  rowName: string
  categorySlug: string
  uiState?: 'visible' | 'removed' | 'hidden'
}) => {
  const rowNameKey = rowName.split(':')[0]
  const rowIndex = rowIndexMapping[rowNameKey as keyof typeof rowIndexMapping]

  trackKeyGrowthEvent('Catalog Page Row Viewed', {
    row_name: rowName,
    row_position_index: rowIndex,
    category: categorySlug,
    ui_state: uiState,
    product: 'MasterClass',
    page_source: getPageSource(),
  })
}
